module.exports = __webpack_public_path__ + "img/img_no_data@2x.c013cb8.png";